import { WalletType as n } from "../../constants/web3.js";
import { useConfigContext as d } from "../config/ConfigContext.js";
import { createStrictContext as b } from "../../util/context/createStrictContext.js";
import { reconnect as x } from "@wagmi/core";
import { useState as t, useEffect as M, useRef as o } from "react";
import { jsx as W } from "react/jsx-runtime";
const [w, O] = b("Web3"), P = (l) => {
  const {
    children: i
  } = l, {
    config: r
  } = d(), {
    web3: c
  } = r, {
    walletConnectId: s,
    wagmiConfig: e
  } = c || {}, [u, a] = t(""), [f, m] = t(!1);
  M(() => {
    e && x(e);
  }, [e]);
  const C = o({
    [n.Ronin]: null,
    [n.RoninMobile]: null
  }), R = o({
    [n.Metamask]: null,
    [n.Ronin]: null,
    [n.RoninMobile]: null,
    [n.Okx]: null,
    [n.WalletConnect]: null,
    [n.None]: null
  }), p = o({
    [n.Metamask]: null,
    [n.Ronin]: null,
    [n.RoninMobile]: null,
    [n.Okx]: null,
    [n.WalletConnect]: null,
    [n.None]: null
  });
  return /* @__PURE__ */ W(w, {
    value: {
      providerMapRef: R,
      roninQRCode: u,
      roninSDKMapRef: C,
      walletConnectId: s || "",
      web3MapRef: p,
      isConnected: f,
      setRoninQRCode: a,
      setIsConnected: m
    },
    children: i
  });
};
export {
  P as Web3Provider,
  O as useWeb3Context
};
//# sourceMappingURL=Web3Context.js.map
